import React from 'react'

import classes from './EmployeeActions.scss'

import EmployeeSelector from './EmployeeSelector/EmployeeSelector'
import EditButton from './EditButton/EditButton'

const employeeActions = ({ recordId, onSelect, selected, editDisabled }) => {
  return (
    <div className={classes.EmployeeActions}>
      <EmployeeSelector onSelect={onSelect} selected={selected} />
      <EditButton recordId={recordId} disabled={editDisabled} />
    </div>
  )
}

export default employeeActions
